import { render, staticRenderFns } from "./cancellationPolicy.vue?vue&type=template&id=2603cc6a&"
import script from "./cancellationPolicy.vue?vue&type=script&lang=js&"
export * from "./cancellationPolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2603cc6a')) {
      api.createRecord('2603cc6a', component.options)
    } else {
      api.reload('2603cc6a', component.options)
    }
    module.hot.accept("./cancellationPolicy.vue?vue&type=template&id=2603cc6a&", function () {
      api.rerender('2603cc6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2jpFF5Kxbv9a1/JS/cancellationPolicy.vue"
export default component.exports